import BaseError from './BaseError';

class InsufficientRewardsError extends BaseError {
  constructor(message: string, fileName?: string, lineNumber?: number) {
    super('InsufficientRewardsError', message, fileName, lineNumber);
  }
}

export default InsufficientRewardsError;
